module.exports = __webpack_public_path__ + "img/hello.4c80fceb.png";